module.exports = __webpack_public_path__ + "static/media/Hospitality_44.887aa454.jpg";